import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { SearchContext } from '../../../../contexts/SearchContext'
import SegmentedControl from '../../../Shared/SegmentedControl'
import { formatProvider, providerLogo } from '../../../../utils/Helper'

const PROVIDERS = ['instagram', 'tiktok', 'youtube', 'linkedin']

const OPTIONS = [
  { value: 'All', label: 'All', title: 'All platforms' },
  ...PROVIDERS.map(provider => ({ value: provider, label: providerLogo(provider), title: formatProvider(provider) }))
]

export default observer(function ProviderFilters() {
  const { search } = useContext(SearchContext)

  return (
    <SegmentedControl
      options={OPTIONS}
      isActive={value => search.provider === value}
      onSelect={value => search.provider = value}
      variant="soft"
    />
  )
})
